interface LandingPageShopReview {
    rating: number;
    message: string;
    author: string;
    date: string;
    city: string;
}

interface LandingPageShop {
    name: string;
    rating: number;
    shop: string;
    reviews: LandingPageShopReview[];
    productsInSell: string;
}

document.addEventListener('DOMContentLoaded', async () => {
    const slug = new URLSearchParams(window.location.search).get('slug');
    if (slug) {
        //@ts-ignore
        const response = await fetch(`/api/landing-page/shop/${slug}?sticky=${window.sticky}`);

        if (!response.ok) {
            console.log('Le point de vente n\'a pas été trouvé a partir du slug renseigné');
        }

        const datas = await response.json() as LandingPageShop;
        const productsInSell = document.querySelector('#productsInSell');
        const generalReviews = document.querySelector('#generalReviews');
        const displayedReviews = document.querySelector('#displayedReviews');
        const popinResult = document.querySelector('#popinResult');
        const shop = document.querySelector('#shop');
        const pdvInfo = document.querySelector('#pdvInfo');

        if (pdvInfo) {
            pdvInfo.classList.remove('noSlug');
        }

        if (generalReviews) {
            generalReviews.classList.remove('col-span-3');
            generalReviews.classList.add('col-span-1');
        }

        if (displayedReviews && datas.reviews.length) {
            const reviewTemplate = displayedReviews.querySelector('[x-data="initReviewBlock"]')?.outerHTML;
            if (reviewTemplate) {
                const contentFragment = document.createDocumentFragment();
                const popinFragment = document.createDocumentFragment();
                datas.reviews.forEach((review, index) => {
                    const newReviewElement = document.createElement('div');
                    newReviewElement.innerHTML = reviewTemplate;
                    const author = newReviewElement.querySelector('.data-review-author') as HTMLDivElement|null;
                    const rating = newReviewElement.querySelector('.data-review-rating') as HTMLDivElement|null;
                    const content = newReviewElement.querySelector('.data-review-content') as HTMLDivElement|null;
                    const date = newReviewElement.querySelector('.data-review-date') as HTMLDivElement|null;
                    const location = newReviewElement.querySelector('.data-review-location') as HTMLDivElement|null;
                    const stars = newReviewElement.querySelector('.data-review-stars') as HTMLDivElement|null;
                    if (author) { author.innerText = review.author; }
                    if (rating) { rating.innerText = review.rating.toString(); }
                    if (content) { content.innerHTML = review.message; }
                    if (date) { date.innerText = review.date; }
                    if (location) { location.innerText = review.city; }
                    if (stars) { stars.innerHTML = '<i class="icon icon--md fa-solid fa-star-sharp text-brand-02" aria-hidden="true"></i>'.repeat(review.rating) + '<i class="icon icon--md fa-regular fa-star-sharp text-brand-02" aria-hidden="true"></i>'.repeat(5 - review.rating); }
                    if (index < 3) {
                        contentFragment.appendChild(newReviewElement);
                    } else {
                        popinFragment.appendChild(newReviewElement);
                    }
                });

                displayedReviews.innerHTML = '';
                displayedReviews.appendChild(contentFragment);

                if (popinResult && datas.reviews.length > 3) {
                    popinResult.innerHTML = '';
                    popinResult.appendChild(popinFragment);
                }
            }
        }

        if (shop) {
            shop.classList.remove('hidden');
            shop.innerHTML = datas.shop;
            shop.querySelector('#shop .horaires > div > div')?.remove();
            shop.querySelector('#shop .horaires > div > div')?.remove();
            const horairesToday = (shop.querySelector('#shop .horaires > div > ul li.font-bold div:last-child') as HTMLDivElement | null)?.innerText;
            if (horairesToday) {
                const horaires = shop.querySelector('#shop .horaires > div');
                if (horaires) {
                    horaires.innerHTML = horairesToday;
                }
            }
        }

        if (productsInSell) {
            productsInSell.innerHTML = datas.productsInSell;
            const productsInSellTile = productsInSell.querySelector("h2");
            if (productsInSellTile) {
                productsInSellTile.innerHTML = `À retrouver chez ${datas.name}`
            }
        }
    }
})
